import { render, staticRenderFns } from "./ImportMenu.vue?vue&type=template&id=4ad49f45"
import script from "./ImportMenu.vue?vue&type=script&lang=js"
export * from "./ImportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports